/**
 * Polyfill for element.matches
 * @source: https://raw.githubusercontent.com/jonathantneal/closest/master/element-closest.js
 */
;(function (ElementProto) {
  if (typeof ElementProto.matches !== 'function') {
    ElementProto.matches =
      ElementProto.msMatchesSelector ||
      ElementProto.mozMatchesSelector ||
      ElementProto.webkitMatchesSelector ||
      function matches(selector) {
        const element = this
        const elements = (element.document || element.ownerDocument).querySelectorAll(selector)
        let index = 0

        while (elements[index] && elements[index] !== element) {
          ++index
        }

        return Boolean(elements[index])
      }
  }
})(window.Element.prototype)
